export const SELECTION_CARD_TITLE_WITH_BADGE_CLASS = 'selection-card--title-with-badge'
